var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97058 11.8332C7.29785 11.6253 7.71582 11.6253 8.04309 11.8332L10.4169 13.3413C11.1683 13.8187 12.1221 13.1501 11.9294 12.2809L11.2641 9.27875C11.1866 8.92913 11.302 8.56476 11.5666 8.32347L13.8261 6.26301C14.4692 5.67659 14.1081 4.60548 13.2413 4.52806L10.3648 4.27117C9.99046 4.23775 9.66648 3.99726 9.52611 3.64864L8.43447 0.937416C8.09813 0.102083 6.91554 0.102084 6.57921 0.937416L5.48756 3.64864C5.34719 3.99726 5.02321 4.23775 4.64888 4.27117L1.77239 4.52806C0.905527 4.60548 0.544452 5.67658 1.18753 6.263L3.44707 8.32347C3.71168 8.56476 3.82706 8.92913 3.74958 9.27875L3.08424 12.2809C2.89161 13.1501 3.84536 13.8187 4.5968 13.3413L6.97058 11.8332Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.275d602a943ba0ebd64b25641778cb8c.svg";
export { ForwardRef as ReactComponent };